import { routerReducer } from 'react-router-redux';
import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import tip from './uis/tip/reduces'
import auth from './pages/sign/reducers'
import icenter from './pages/home/routes/icenter/reducers/list'
import userManagement from './pages/home/routes/user/reducers/list'
import permission from './pages/home/routes/permission/reducers/list'
import recharge from './pages/home/routes/recharge/reducers/list'
import global from './pages/home/routes/global/reducers/list'
import notice from './pages/home/routes/notice/reducers/list'
import modules from './pages/home/routes/modules/reducers/list'
import news from './pages/home/routes/news/reducers/list'
import orderSd from './pages/home/routes/order_sd/reducers/list';
import orderDomain from './pages/home/routes/order_domain/reducers/list'; 
import orderJzhz from './pages/home/routes/order_jzhz/reducers/list';
import orderCopy from './pages/home/routes/order_copy/reducers/list';
import orderMy from './pages/home/routes/order_my/reducers/list';
import invoice from './pages/home/routes/invoice/reducers/list'; 
import siteTemplate from './pages/home/routes/site_template/reducers/list'; 
import baojiadan from './pages/home/routes/baojiadan/reducers/list'; 
import questionAnswer from './pages/home/routes/question_answer/reducers/list'; 
import blacklist from './pages/home/routes/blacklist/reducers/list';
import todoTask from './pages/home/routes/todo_task/reducers/list'; 
import photoGallery from './pages/home/routes/photo_gallery/reducers/list'; 
import orderRenew from './pages/home/routes/order_renew/reducers/list'; 
// import new reducers


export default combineReducers({
    router: routerReducer,
    form: formReducer,
    tip,
    auth,
    icenter,
    userManagement,
    permission,
    recharge,
    global,
    notice,
    modules,
    news,
    orderSd, 
    orderDomain,
    orderJzhz,
    orderCopy,
    orderMy,
    invoice,
    siteTemplate, 
    baojiadan,
questionAnswer, 
blacklist, 
todoTask,
photoGallery, 
orderRenew, 
// combine new reducers
})


// WEBPACK FOOTER //
// ./src/reducers.js